import React from 'react'
import './Loder.css';

export default function Loder() {
  return (
    <div>
       <span class="loader"></span>
    </div>
  )
}
